module.exports = __webpack_public_path__ + "img/three.66cfa7fb.svg";